import { useEffect, useReducer } from "react";
import { useDispatch, useSelector } from "react-redux";
import { validateMfaLogin } from "../../api/auth";

import {
  Alert,
  Box,
  Button,
  CircularProgress,
  TextField,
} from "@mui/material";
import ShieldOutlinedIcon from "@mui/icons-material/ShieldOutlined";
import AuthLayout, { authButtonClass } from "../../components/AuthLayout.jsx";
import { useState } from "react";
import { getUser } from "../../actions/auth";
import { useNavigate } from "react-router-dom";
const email = sessionStorage.getItem("email");
const initialState = { error: "", loading: false, success: false };
function reducer(state, action) {
  switch (action.type) {
    case "SUCCESS":
      return { ...initialState, loading: false, success: true };
    case "ERROR":
      return { error: action.payload, loading: false, success: true };
    default:
      return state;
  }
}
export default function LoginMfa() {
  const [localState, dispatch] = useReducer(reducer, initialState);
  const globalDispatch = useDispatch();
  const navigate = useNavigate();
  const user = useSelector((state) => state.user);
  const [loading, setLoading] = useState(false);

  const [mfaOtp, setMfaOtp] = useState("");

  useEffect(() => {
    if (user.data.token) {
      navigate("/", { replace: true });
    }
  }, [user.data.token]);

  const onFormSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await validateMfaLogin(email, mfaOtp);
      if (data.id) {
        globalDispatch(getUser(data.token));
        localStorage.setItem("token", data.token);
      } else {
        dispatch({ type: "ERROR", payload: "Wrong OTP" });
      }
    } catch (error) {
      alert(error.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthLayout
      title="Two-step verification"
      subtitle={`Enter the one-time code sent to ${email}`}
      icon={<ShieldOutlinedIcon />}
    >
      <Box component="form" onSubmit={onFormSubmit} display="flex" flexDirection="column" gap={2.2}>
        {Boolean(localState.error) ? <Alert severity="error">{localState.error}</Alert> : null}
        <TextField
          value={mfaOtp}
          onChange={(e) => setMfaOtp(e.target.value)}
          variant="outlined"
          fullWidth
          required
          label="Verification code"
          autoFocus
          autoComplete="one-time-code"
          inputProps={{ style: { letterSpacing: 8, fontWeight: 600, textAlign: "center", fontSize: 20 } }}
        />
        <Button type="submit" variant="contained" fullWidth size="large" disabled={loading} className={authButtonClass}>
          {loading ? <CircularProgress size={24} className="!text-white" /> : "Verify & sign in"}
        </Button>
      </Box>
    </AuthLayout>
  );
}
